import React from "react";
import "../css/Experience.scss";
const Experience = () => {
  return (
    <div className="container experience">
      <h1 className="title">Work Experience</h1>
      <div className="career">
        <div className="bubbles-container">
          <svg
            className="bubbles"
            style={{ overflow: "visible" }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 701 1024">
            <g className="bubbles-large" stroke-width="7">
              <g>
                <g transform="translate(10 940)">
                  <circle cx="35" cy="35" r="35" />
                </g>
              </g>
              <g>
                <g transform="translate(373 940)">
                  <circle cx="35" cy="35" r="35" />
                </g>
              </g>
              <g>
                <g transform="translate(408 940)">
                  <circle cx="35" cy="35" r="35" />
                </g>
              </g>
              <g>
                <g transform="translate(621 940)">
                  <circle cx="35" cy="35" r="35" />
                </g>
              </g>
              <g>
                <g transform="translate(179 940)">
                  <circle cx="35" cy="35" r="35" />
                </g>
              </g>
            </g>

            <g className="bubbles-small" stroke-width="4">
              <g>
                <g transform="translate(147 984)">
                  <circle cx="15" cy="15" r="15" />
                </g>
              </g>
              <g>
                <g transform="translate(255 984)">
                  <circle cx="15" cy="15" r="15" />
                </g>
              </g>
              <g>
                <g transform="translate(573 984)">
                  <circle cx="15" cy="15" r="15" />
                </g>
              </g>
              <g>
                <g transform="translate(429 984)">
                  <circle cx="15" cy="15" r="15" />
                </g>
              </g>
              <g>
                <g transform="translate(91 984)">
                  <circle cx="15" cy="15" r="15" />
                </g>
              </g>
              <g>
                <g transform="translate(640 984)">
                  <circle cx="15" cy="15" r="15" />
                </g>
              </g>
              <g>
                <g transform="translate(321 984)">
                  <circle cx="15" cy="15" r="15" />
                </g>
              </g>
              <g>
                <g transform="translate(376 984)">
                  <circle cx="15" cy="15" r="15" />
                </g>
              </g>
              <g>
                <g transform="translate(376 984)">
                  <circle cx="15" cy="15" r="15" />
                </g>
              </g>
              <g>
                <g transform="translate(497 984)">
                  <circle cx="15" cy="15" r="15" />
                </g>
              </g>
            </g>
          </svg>
        </div>
        <ul className="timeline">
          <li className="timeline-item">
            <span className="timeline-date">2020 - Present</span>
            <h2 className="freelancer ">FREELANCER</h2>
            <h3>
              <span className="underline">Web Developer</span> | Oct 2020 -
              Present (2years+)<br></br>
              <span className="underline">And Digital Marketer</span> | Oct 2020
              - Oct 2021 (1year)
            </h3>

            <ul style={{ listStyleType: "square" }} className="pr">
              <li>
                Collaborated with clients to develop site-map guidelines and
                requirements to capture content, features and functionality for
                site development efforts
              </li>
              <br />
              <li>
                Developed custom desktop and mobile-friendly WordPress templates
                to align with site design and branding for clients
              </li>
              <br />

              <li>
                Managed and scheduled all production for online commercial
              </li>
              <br />

              <li>
                Created Facebook and Instagram content for each social media
                site
              </li>
              <br />

              <li>
                Executed paid social media campaigns across Facebook and
                Instagram
              </li>
              <br />

              <li>
                Provided solutions to technical issue related to e-commerce and
                social media platforms
              </li>
              <br />

              <li>
                Provided customer support for sales and after sales services
              </li>
            </ul>
          </li>
          <li className="timeline-item">
            <span className="timeline-date">2013</span>
            <h2>BACHELOR GRADUATION PROJECT</h2>
            <h3>Research Experience | 2013</h3>
            <ul style={{ listStyleType: "square" }} className="pr">
              <li>
                Research and Experiment Optical Character Recognition (OCR) with
                .NET framework based on C#
              </li>
            </ul>
          </li>
          <li className="timeline-item">
            <span className="timeline-date">2012</span>
            <h2>SOFTWARE DEVELOPER (TRAINEE)</h2>
            <h3>Adasoft, Thailand | May 2012 - Nov 2012 (6months)</h3>
            <ul style={{ listStyleType: "square" }} className="pr">
              <li>
                Collaborated with our team including our System Analysts,
                Software Developers, Testers, Project Managers to develop POS
                Systems
              </li>
            </ul>
          </li>
        </ul>
      </div>

      {/* <div>
        <h3>
          <span className="underline">Web Developer</span> | Oct 2020 - Present
          (2years+)<br></br>
          <span className="underline">And Digital Marketer</span> | Oct 2020 -
          Oct 2021 (1year)
        </h3>
        <p>
          <li>
            Collaborated with clients to develop site-map guidelines and
            requirements to capture content, features and functionality for site
            development efforts
          </li>
          <li>
            Developed custom desktop and mobile-friendly WordPress templates to
            align with site design and branding for clients
          </li>
          <li>Managed and scheduled all production for online commercial</li>
          <li>
            Created Facebook and Instagram content for each social media site
          </li>
          <li>
            Executed paid social media campaigns across Facebook and Instagram
          </li>
          <li>
            Provided solutions to technical issue related to e-commerce and
            social media platforms
          </li>
          <li>Provided customer support for sales and after sales services</li>
        </p>
      </div>
      <div>
        <h2>SOFTWARE DEVELOPER (TRAINEE)</h2>
        <h3>Adasoft, Thailand | May 2012 - Nov 2012 (6months)</h3>
        <p>
          <li>
            Collaborated with our team including our System Analysts, Software
            Developers, Testers, Project Managers to develop POS Systems
          </li>
        </p>
      </div>
      <div>
        <h2>BACHELOR GRADUATION PROJECT</h2>
        <h3>Research Experience | 2013</h3>
        <p>
          Research and Experiment Optical Character Recognition (OCR) with .NET
          framework based on C#
        </p>
      </div> */}
    </div>
  );
};

export default Experience;
